import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Lager 1",
  viewBox: "0 0 500 500"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#d3294d",
      d: "m489.33 277.68-133.6 143.67c-7.81 8.41-21.11 8.41-28.93 0L193.23 277.68c-7.42-7.98-6.97-20.46 1-27.9h.03c7.98-7.46 20.49-7.01 27.91.99l99.39 106.94V256.58c0-79.95-64.8-144.75-144.75-144.75H24.42c-10.9 0-19.74-8.84-19.74-19.74 0-5.46 2.21-10.39 5.78-13.96 3.58-3.57 8.52-5.78 13.96-5.78H176.8c101.75 0 184.24 82.49 184.24 184.24v101.05l99.34-106.86c7.43-8 19.93-8.45 27.92-1h.01c7.98 7.45 8.43 19.93 1 27.91Z"
    }, null, -1)
  ]))]))
}
export default { render: render }